export const GET_CATH_DOCUMENT = 'GET_CATH_DOCUMENT'
export const CATH_DOC_LOADING = 'CATH_DOC_LOADING'
export const CLEAR_CATH = 'CLEAR_CATH'
export const RESET_CATH_MODAL = 'RESET_CATH_MODAL'
